<ng-container *ngFor="let row of rows">
    <div class="row">
        <ng-container *ngFor="let panel of row; let last = last, let first = first" [ngSwitch]="panel.type">
            <lm-twelve-column-panel-list #dashboardPanel
                                     *ngSwitchCase="'list'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (contentModified)="onContentModified($event)"
                                     (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                                     (panelTransactionEvent)="onPanelTransactionEvent($event)"
            ></lm-twelve-column-panel-list>

            <lm-twelve-column-panel-list #dashboardPanel
                                     *ngSwitchCase="'formlist'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (contentModified)="onContentModified($event)"
                                     (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                                     (panelTransactionEvent)="onPanelTransactionEvent($event)"
            ></lm-twelve-column-panel-list>

            <lm-twelve-column-panel-form #dashboardPanel
                                     *ngSwitchCase="'standardform'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [formUrlInfo]="formUrlInfo"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-form #dashboardPanel
                                     *ngSwitchCase="'form'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [formUrlInfo]="formUrlInfo"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     [model]="model"
                                     [placeHolder]="placeHolder"
                                     [specFields]="specFields"
                                     (componentDisplayed)="onComponentDisplayed()"
                                     (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-form #dashboardPanel
                                     *ngSwitchCase="'independentform'"
                                     [ngClass]="{'last-child': last, 'first-child': first}"
                                     [panel]="panel"
                                     [fromDataView]="fromDataView"
                                     [messageRuleView]="messageRuleView"
                                     (componentDisplayed)="onComponentDisplayed()"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-form-template #dashboardPanel
                                              *ngSwitchCase="'templateform'"
                                              [ngClass]="{'last-child': last, 'first-child': first}"
                                              [panel]="panel"
                                              [fromDataView]="fromDataView"
                                              [messageRuleView]="messageRuleView"
                                              [model]="model"
                                              [placeHolder]="placeHolder"
                                              [specFields]="specFields"
                                              (componentDisplayed)="onComponentDisplayed()"
            ></lm-twelve-column-panel-form-template>

            <lm-twelve-column-panel-form #dashboardPanel
                 *ngSwitchCase="'instancecountchart'"
                 [ngClass]="{'last-child': last, 'first-child': first}"
                 [panel]="panel"
                 [fromDataView]="fromDataView"
                 [messageRuleView]="messageRuleView"
                 (componentDisplayed)="onComponentDisplayed()"
                 (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-card
                    *ngSwitchCase="'cardview'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="fromDataView"
                    [messageRuleView]="messageRuleView"
                    (uiLinkEvent)="onUILinkEvent($event)"
            ></lm-twelve-column-panel-card>

            <lm-twelve-column-panel-form
                    *ngSwitchCase="'menuPanel'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="messageRuleView"
                    [messageRuleView]="messageRuleView"
                    (componentDisplayed)="onComponentDisplayed()"
                    (fieldEvent)="onFieldEvent($event)"
            ></lm-twelve-column-panel-form>

            <lm-twelve-column-panel-url
                    *ngSwitchCase="'url'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="fromDataView"
                    [messageRuleView]="messageRuleView"
                    (uiLinkEvent)="onUILinkEvent($event)"
            ></lm-twelve-column-panel-url>

            <lm-twelve-column-panel-url
                    *ngSwitchCase="'link'"
                    [ngClass]="{'last-child': last, 'first-child': first}"
                    [panel]="panel"
                    [fromDataView]="fromDataView"
                    [messageRuleView]="messageRuleView"
                    (uiLinkEvent)="onUILinkEvent($event)"
            ></lm-twelve-column-panel-url>

        </ng-container>
    </div>
</ng-container>
